import { apiAuthority, ApiUserinfo, IUserInfo, ResAuthority, ResCallBack, ResCheckWxUser } from "@/api";
import { ALL_POWER, convertStr, ENTRY, external, isUsable, judgeModulePower, Powers, TABS } from "@/config";
import { PromiseSleep } from "@/utils";
import { defineStore } from "pinia";
import { showDialog } from "vant";
export const env = import.meta.env;
export const isDevelopment = env.MODE == "development";

interface State {
  active: TABS;
  multiUserinfo: {
    [key: string]: ResCallBack;
  };
  additionGroup: {
    // 附加信息
    [key: string]: ResCheckWxUser;
  };
  corpId: string;
  entry: ENTRY; // 入口
  external: string;
  loading: boolean;
  authority: ResAuthority;
  powers: Powers | string;
  // 当前登录用户信息
  userinfo: IUserInfo;
  isLogout: boolean;
}

export const useStore = defineStore({
  id: "useStore",
  state: (): State => ({
    active: TABS.CLIENT,
    multiUserinfo: {},
    additionGroup: {},
    authority: {} as ResAuthority,
    corpId: "",
    entry: ENTRY.SINGLE_CHAT_TOOLS,
    external: "",
    loading: false,
    powers: {} as Powers,
    userinfo: {} as IUserInfo,
    isLogout: false,
  }),
  getters: {
    getToken: (state: State) => state.multiUserinfo[state.corpId]?.token || "",
    getCorpId: (state: State) => state.corpId,
    getEntry: (state: State) => state.entry,
    getExternal: (state: State) => state.external,
    getUserinfo: (state: State) => state.multiUserinfo[state.corpId] || {},
    getAddition: (state: State) => state.additionGroup[state.corpId] || {},
    getPower:
      (state: State) =>
      (name: TABS, alone?: ALL_POWER): boolean => {
        if (state.powers == "administrator") return true;
        if (String(state.powers) == "{}") return false;
        if (!alone) return (<Powers>state.powers)[name]?.module;
        else return (<Powers>state.powers)[name]?.[alone];
      },
    getIsLogout: (state: State) => state.isLogout,
  },
  actions: {
    setIsLogout(bol: boolean) {
      this.isLogout = bol;
    },
    /** 设置当前登录用户信息 */
    async setNowUserinfo() {
      const { data } = await ApiUserinfo();
      console.log("=== 完整用户信息 ===", JSON.stringify(data, null, 2));
      console.log("=== 用户信息对象 ===", data);
      this.userinfo = data;
    },
    async setLoading(bol: boolean) {
      await PromiseSleep(0);
      this.loading = bol;
    },
    setUserinfo(obj: ResCallBack) {
      this.multiUserinfo[this.corpId] = obj;
    },
    setAddition(obj: ResCheckWxUser) {
      this.additionGroup[this.corpId] = obj;
    },
    setToken(token: string) {
      this.multiUserinfo[this.corpId].token = token;
    },
    async setCorpId(corpId: string) {
      this.corpId = corpId;
    },
    async setEntry(): Promise<void> {
      return new Promise((resolve) => {
        wx.invoke("getContext", {}, (res: any) => {
          if (res.err_msg == "getContext:ok") {
            this.entry = res.entry;
            resolve();
          } else {
            //错误处理
          }
        });
        if (isDevelopment) setTimeout(resolve, 500);
      });
    },
    async setExternal(): Promise<void> {
      return new Promise((resolve) => {
        wx.invoke(external(this.entry), {}, async (res: any) => {
          console.log(res);
          if (["getCurExternalContact:ok", "getCurExternalChat:ok"].includes(res.err_msg)) {
            this.external = res?.userId || res.chatId;
            resolve();
          } else {
            //错误处理
            this.setLoading(false);
            if (isUsable(this.entry)) {
              await showDialog({ title: "提示", message: "您需要允许获取联系人信息后才可进入使用，点击重试", confirmButtonText: "重试" });
              await this.setExternal();
            } else {
              await showDialog({ title: "提示", message: "外部联系人信息未获取到，无法通过此途径进入该应用，请从工具栏进入", confirmButtonText: "确认" });
            }
            resolve();
          }
        });
        if (isDevelopment) setTimeout(resolve, 500);
      });
    },
    async setPower() {
      const { data } = await apiAuthority();
      this.authority = { ...data, allPower: data.crsAuthority + convertStr(data.financialAuthority) };
      this.powers = data.crsAuthority == "administrator" ? data.crsAuthority : judgeModulePower(this.authority.allPower);
      console.log(this.powers);
    },
  },
  persist: [
    {
      storage: localStorage,
      paths: ["multiUserinfo", "corpId", "entry", "external", "isLogout"],
    },
  ],
});
